import { getDeviceType } from '@/shared/lib/browser';

export const isMobileLikeDevice = (): boolean => {
  if (typeof navigator === 'undefined') return false;
  const t = getDeviceType();
  return t === 'mobile' || t === 'tablet';
};
